<template>
    <Component :is="variationComponents[slice.variation as keyof typeof variationComponents]" v-bind="props" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {ListSlice} from '@prismicio-types';
    import ListDefault from './variations/ListDefault.vue';
    import ListWithBackground from './variations/ListWithBackground.vue';
    import ListWithImage from './variations/ListWithImage.vue';

    const props = defineProps(getSliceComponentProps<ListSlice>());

    const variationComponents = {
        default: ListDefault,
        withBackground: ListWithBackground,
        listWithImage: ListWithImage,
    };
</script>
